import EventBase from './EventBase'
import EventID from './EventID'

/**
 * 212  -  图片按钮选项
 */

export default class EventButtonDifChoose extends EventBase {
  /**
   * 图片按钮选项的构造函数
   */
  constructor() {
    super()
    this.Parameter = ['0', '', '']
  }

  setLocalesParam(indexes: number[]): void {
    indexes = [1]
  }

  // #region 事件内主要属性参数
  /**
   * 在整个分歧按钮里的位置
   */
  get Index() {
    return parseInt(this.Parameter?.[0] ?? '')
  }
  set Index(value) {
    this.Parameter![0] = value.toString()
  }
  /**
   * 按钮名称多语言key 
   */
  get Name() {
    return this.Parameter?.[1] ?? ''
  }
  set Name(value) {
    this.Parameter![1] = value
  }


  /**
   * 描述信息
   */
  get Description() {
    return this.Parameter?.[2] ?? ''
  }
  set Description(value) {
    this.Parameter![2] = value
  }
  // #endregion

  /**
   * 事件ID
   */
  Code = EventID.ButtonDifChoose

  /**
   * 获得该事件在事件列表的描述信息
   */
  /// <returns>事件描述信息</returns>
}
